<template>
  <div class="start-menu-container">
    <button @click="toggleMenu" :class="{ active: isOpen }">
      ▶ Start
    </button>

    <transition name="start-menu">
      <div v-if="isOpen" class="window start-menu-popup">
        <div class="title-bar">
          <div class="title-bar-text">Menu</div>
        </div>
        <div class="start-menu-items">
          <div class="start-menu-item" @click="openAbout">
            <span>📄</span> About Oliver
          </div>
          <div class="start-menu-item" @click="openProfile">
            <span>👤</span> Celery Man
          </div>
          <div class="start-menu-item" @click="openContact">
            <span>✉</span> Contact
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "StartMenu",
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    openAbout() {
      this.$emit('open-about');
      this.isOpen = false;
    },
    openProfile() {
      this.$emit('open-profile');
      this.isOpen = false;
    },
    openContact() {
      this.$emit('open-contact');
      this.isOpen = false;
    },
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.isOpen = false;
      }
    });
  }
};
</script>

<style src="98.css"></style>
<style scoped>
.start-menu-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10000;
}

.start-menu-popup {
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 180px;
  margin-bottom: 2px;
}

.start-menu-items {
  padding: 4px 0;
}

.start-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 12px;
  cursor: default;
}

.start-menu-item:hover {
  background: #000080;
  color: white;
}

.start-menu-enter-active, .start-menu-leave-active {
  transition: opacity 0.1s ease;
}

.start-menu-enter-from, .start-menu-leave-to {
  opacity: 0;
}
</style>
